import React from 'react';

const SET_LANGUAGE = "SET_LANGUAGE";
const SET_TEMPLATE_CODE = "SET_TEMPLATE_CODE";
const SET_ATTEMPT_ID = "SET_ATTEMPT_ID"

const LanguageContext = React.createContext({
    state: { language: null },
    dispatch: () => { }
});

const LanguageSelectionReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_LANGUAGE:
            return {
                ...state,
                language: payload.language,
            }
        case SET_TEMPLATE_CODE:
            return {
                ...state,
                templateCode: payload.templateCode,
            }
        case SET_ATTEMPT_ID:
            return {
                ...state,
                attemptId: payload.attemptId,
            }
        default:
            return state;
    }
}

const LanguageSelectionProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(LanguageSelectionReducer, {
        language: null
    })

    return (
        <LanguageContext.Provider value={{ state, dispatch }}>
            {children}
        </LanguageContext.Provider>
    )
}

export { LanguageContext, LanguageSelectionProvider, SET_LANGUAGE, SET_TEMPLATE_CODE, SET_ATTEMPT_ID };
